import { Box, Typography } from '@mui/material';
import React from 'react';
import RecentSearches from './RecentSearches';
import LoadingIndicator from './LoadingIndicator';
import { isEmptyArray, isEmptyObj } from '../../helpers/other';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import SearchResults from './SearchResults';
import { dataTypePathMap } from './constants';
import { getListUrlFromPath } from '../../routes/constants';
import { styled } from '@mui/material/styles';
import NoDataMessage from './NoDataMessage';
import { History } from '@mui/icons-material';

function shiftElementToStart(array, element) {
  const index = array.indexOf(element);
  if (index !== -1) {
    array.splice(index, 1);
    array.unshift(element);
  }
  return array;
}

const Footer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '35px',
  backgroundColor: theme.palette.grey[100],
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  borderTop: `1px solid ${theme.palette.divider}`,
}));

const DropdownFooter = () => (
  <Footer>
    <Typography>Showing limited results</Typography>
  </Footer>
);

const SearchContainer = ({
  recentSearches,
  loading,
  inputValue,
  setInputValue,
  searchTerm,
  setSearchTerm,
  setRecentSearches,
  searchResult,
  onClose,
}) => {
  const history = useHistory();

  const handleSelect = (item) => {
    setInputValue(item);
    setSearchTerm(item);
    setRecentSearches(shiftElementToStart(recentSearches, item));
  };

  const handleResultSelect = (data) => {
    if (!data) return;

    const path = dataTypePathMap?.[data?.data_type];
    if (!path) return;

    const url = data?.data_type === 4 ? `${path}?draft_id=${data?.data_id}` : getListUrlFromPath(path, data?.data_id);

    if (url) {
      history.push(url);
      onClose();
    }
  };

  const shouldShowFooter =
    (!searchTerm && !isEmptyArray(recentSearches)) || (!isEmptyObj(searchResult) && inputValue && searchTerm);

  return (
    <>
      <Box height="100%" position="relative" overflow="auto" marginBottom="35px" p={1} data-testid="search-container">
        {loading ? (
          <LoadingIndicator />
        ) : (
          <>
            {!inputValue && !searchTerm && isEmptyArray(recentSearches) && (
              <NoDataMessage
                message={
                  <Box display="flex" alignItems="center" gap={1}>
                    <History />
                    No Search History
                  </Box>
                }
              />
            )}
            {inputValue && !searchTerm && isEmptyArray(recentSearches) && (
              <NoDataMessage message="Press Enter or 🔍 to search data" />
            )}
            {!searchTerm && !isEmptyArray(recentSearches) && (
              <RecentSearches items={recentSearches} onSelect={handleSelect} inputValue={inputValue} />
            )}
            {inputValue && searchTerm && isEmptyObj(searchResult) && <NoDataMessage message="No Search Results !" />}
            {inputValue && searchTerm && searchResult && (
              <SearchResults results={searchResult} onResultSelect={handleResultSelect} inputValue={inputValue} />
            )}
          </>
        )}
      </Box>
      {!loading && shouldShowFooter && <DropdownFooter />}
    </>
  );
};

export default SearchContainer;
